import { Typography } from '@mui/material';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import { useGetUserNotificationConnections } from '@hooks/api/notification';

import type { Profile } from '@models/session';

import UserNotificationConnection from '@views/ManageAccount/AccessManagement/Components/UserNotificationConnection';

const messages = defineMessages({
  notifications: {
    id: 'accessManagement.notifications',
    defaultMessage: 'Notifications',
  },
});

interface NotificationsProps {
  user?: Profile;
  accessingUser?: Profile;
  loading: boolean;
}

function Notifications({
  accessingUser,
  user,
  loading: baseLoading,
}: NotificationsProps) {
  const { formatMessage } = useIntl();

  const { data: connections, loading: connectionsLoading } =
    useGetUserNotificationConnections({ user_id: user?.user_id });

  const isEmailEnabled = connections.find(
    ({ connected_user_id }) => connected_user_id === accessingUser?.user_id
  )?.email_enabled;

  if (!user || !accessingUser) {
    return null;
  }

  return (
    <>
      <Typography variant="subtitle2">
        {formatMessage(messages.notifications)}
      </Typography>
      <UserNotificationConnection
        user={user}
        connectingUser={accessingUser}
        email_enabled={isEmailEnabled ?? false}
        loading={baseLoading || connectionsLoading}
      />
    </>
  );
}

export default withErrorBoundary(Notifications, {
  FallbackComponent: (props) => {
    const { formatMessage } = useIntl();
    return (
      <>
        <Typography variant="subtitle2">
          {formatMessage(messages.notifications)}
        </Typography>
        <ErrorBoundaryFallback {...props} />
      </>
    );
  },
});
